"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CompaniesLeaderboard", {
  enumerable: true,
  get: function () {
    return _companiesLeaderboard.default;
  }
});
Object.defineProperty(exports, "CompanyLeaderboard", {
  enumerable: true,
  get: function () {
    return _companyLeaderboard.default;
  }
});
exports.EventsDetails = EventsDetails;
Object.defineProperty(exports, "IndividualLeaderboard", {
  enumerable: true,
  get: function () {
    return _individualLeaderboard.default;
  }
});
Object.defineProperty(exports, "TCompanyLeaderboardDisplayType", {
  enumerable: true,
  get: function () {
    return _companyLeaderboard.TCompanyLeaderboardDisplayType;
  }
});
Object.defineProperty(exports, "TEventsDetailsTab", {
  enumerable: true,
  get: function () {
    return _tabs.TEventsDetailsTab;
  }
});
Object.defineProperty(exports, "TLeaderboardSize", {
  enumerable: true,
  get: function () {
    return _sizes.TLeaderboardSize;
  }
});
Object.defineProperty(exports, "TSelectedZone", {
  enumerable: true,
  get: function () {
    return _companiesLeaderboard.TSelectedZone;
  }
});
Object.defineProperty(exports, "fakeRegions", {
  enumerable: true,
  get: function () {
    return _companyLeaderboard.fakeRegions;
  }
});
Object.defineProperty(exports, "fakeSites", {
  enumerable: true,
  get: function () {
    return _companyLeaderboard.fakeSites;
  }
});
Object.defineProperty(exports, "fakeTeams", {
  enumerable: true,
  get: function () {
    return _companyLeaderboard.fakeTeams;
  }
});
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Tabs2 = _interopRequireDefault(require("@mui/material/Tabs"));
var _Tab2 = _interopRequireDefault(require("@mui/material/Tab"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../hooks");
var _services = require("../../services");
var _companiesLeaderboard = _interopRequireWildcard(require("./companies-leaderboard"));
var _home = _interopRequireDefault(require("./companies-leaderboard/home"));
var _companyLeaderboard = _interopRequireWildcard(require("./company-leaderboard"));
var _faq = _interopRequireDefault(require("./faq"));
var _home2 = _interopRequireDefault(require("./home"));
var _individualLeaderboard = _interopRequireDefault(require("./individual-leaderboard"));
var _home3 = _interopRequireDefault(require("./individual-leaderboard/home"));
var _sizes = require("./sizes");
var _tabs = require("./tabs");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EventsDetails({
  disableIndividualLeaderboard,
  disableInternalLeaderboard,
  internalLeaderboardDisplayTypes,
  leaderboardDisplayed,
  ...props
}) {
  const {
    event,
    selectedTab,
    selectTab
  } = props;
  const [defaultParticipationGroup, setDefaultParticipationGroup] = (0, _react.useState)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    if (event.defaultParticipationGroup) getDefaultParticipationGroup(event.defaultParticipationGroup);else setDefaultParticipationGroup(null);
    return () => {
      cancelPromises();
      setDefaultParticipationGroup(undefined);
    };
  }, [event]);
  async function getDefaultParticipationGroup(geoGroupId) {
    try {
      const group = await cancellablePromise(_services.GeogroupService.getGeogroup({
        geoGroupId
      }));
      setDefaultParticipationGroup(group);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
        setDefaultParticipationGroup(null);
      }
    }
  }
  if (leaderboardDisplayed) {
    if (selectedTab === 'companiesLeaderboard') {
      return /*#__PURE__*/_react.default.createElement(_companiesLeaderboard.default, props);
    }
    if (selectedTab === 'individualLeaderboard') {
      return /*#__PURE__*/_react.default.createElement(_individualLeaderboard.default, props);
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Tabs2.default, {
    onChange: (_, tab) => selectTab(tab),
    value: selectedTab
  }, _tabs.eventsDetailsTab.filter(key => (key !== 'internalLeaderboard' || !disableInternalLeaderboard) && (key !== 'individualLeaderboard' || !disableIndividualLeaderboard)).map(key => /*#__PURE__*/_react.default.createElement(_Tab2.default, {
    key: key,
    label: t(_tabs.eventsDetailsTabMap[key].labelKey),
    sx: {
      minHeight: 48,
      textTransform: 'initial'
    },
    value: key
  }))), /*#__PURE__*/_react.default.createElement(_Divider2.default, null), selectedTab === 'home' && /*#__PURE__*/_react.default.createElement(_home2.default, _extends({
    defaultParticipationGroup: defaultParticipationGroup
  }, props)), selectedTab === 'companiesLeaderboard' && /*#__PURE__*/_react.default.createElement(_home.default, props), selectedTab === 'individualLeaderboard' && /*#__PURE__*/_react.default.createElement(_home3.default, props), selectedTab === 'internalLeaderboard' && /*#__PURE__*/_react.default.createElement(_companyLeaderboard.default, _extends({}, props, {
    displayTypes: internalLeaderboardDisplayTypes
  })), selectedTab === 'faq' && /*#__PURE__*/_react.default.createElement(_faq.default, null));
}